/*
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2024, Zumper
 */

import { Flex } from '@chakra-ui/react'
import { selectIsBot } from '@zcode-ui/web-zumper-global-state'
import { useGeoLocation } from '@zcode/nr/es/shared/components/GeoLocation'
import { selectUrl } from '@zcode/nr/es/shared/components/GeoLocation/selectors'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setIsSpotlightListablesLoading } from '../../modules/homepage/actions'
import { AboutAppLazyLoadableSection } from './AboutApp/AboutAppLazyLoadableSection'
import { FAQLazyLoadableSection } from './FAQSection/FAQLazyLoadableSection'
import { HomepageExploreRentalsLazyLoadable } from './HomepageExploreRentals/HomepageExploreRentalsLazyLoadable'
import { HomepageSpotlightListingsLazyLoadableSection } from './HomepageSpotlightListings/HomepageSpotlightListingsLazyLoadableSection'
import loadHomepageSpotlightListings from './HomepageSpotlightListings/loadHomepageSpotlightListings'
import { MarketingLazyLoadableSection } from './MarketingSection/MarketingLazyLoadableSection'
import { NationalRentReportLazyLoadableSection } from './NationalRentReport/NationalRentReportLazyLoadableSection'
import { PopularCitiesLazyLoadableSection } from './PopularCities/PopularCitiesLazyLoadableSection'
import { NewPressLazyLoadableSection } from './Press/NewPressLazyLoadableSection'
import { RentingMadeEasy } from './RentingMadeEasy/RentingMadeEasy'

export const HomepageContent = () => {
  const isBot = useSelector(selectIsBot)
  const dispatch = useDispatch()
  const [getGeoLocation, isSafeForClientOnly] = useGeoLocation()
  const geoLocation = isSafeForClientOnly ? getGeoLocation() : {}
  const url = selectUrl(geoLocation)

  useEffect(() => {
    if (url) {
      dispatch(loadHomepageSpotlightListings(url))
    } else {
      dispatch(setIsSpotlightListablesLoading(false))
    }
  }, [url, dispatch])

  return (
    <Flex
      backgroundColor="gray.0"
      paddingX={{ base: 6, desktop: 16, lg: '120px', xl: 'unset' }}
      gap={{ base: 16, xl: '120px' }}
      flexDir="column"
      maxW={{ xl: '1200px' }}
      marginX={{ xl: 'auto' }}
      marginTop={{ base: 16, lg: 32 }}
    >
      <RentingMadeEasy />
      <HomepageSpotlightListingsLazyLoadableSection rootMargin="400px" />
      {!isBot ? <HomepageExploreRentalsLazyLoadable rootMargin="400px" /> : null}
      <PopularCitiesLazyLoadableSection />
      <AboutAppLazyLoadableSection />
      <NationalRentReportLazyLoadableSection />
      <MarketingLazyLoadableSection />
      <NewPressLazyLoadableSection />
      <FAQLazyLoadableSection />
    </Flex>
  )
}
